import React, { useState, useEffect } from 'react';
import { 
  Box, Typography, Card, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Chip
} from '@mui/material';
import api from '../../utils/axios';
import { toast } from 'react-toastify';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await api.get('/superadmin/audit-logs');
      if (res.data.success) {
        setLogs(res.data.data);
      }
    } catch (err) {
      toast.error('Failed to load audit logs');
    } finally {
      setLoading(false);
    }
  };

  const getActionColor = (action) => {
    if (action.includes('UPDATE')) return 'primary';
    if (action.includes('DELETE')) return 'error';
    if (action.includes('ADD')) return 'success';
    if (action.includes('PASSWORD')) return 'warning';
    return 'default';
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Audit Logs</Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        Chronological record of sensitive actions performed by staff.
      </Typography>
      
      <Card sx={{ mt: 3, overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: '70vh' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Performed By</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Details</TableCell>
                <TableCell>Target User/Church</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log) => (
                <TableRow key={log._id} hover>
                  <TableCell>{new Date(log.createdAt).toLocaleString()}</TableCell>
                  <TableCell>
                    {log.performedBy?.firstName} {log.performedBy?.lastName}
                    <Typography variant="caption" display="block" color="text.secondary">
                      {log.performedBy?.email}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip label={log.action} color={getActionColor(log.action)} size="small" />
                  </TableCell>
                  <TableCell sx={{ maxWidth: 300 }}>{log.details}</TableCell>
                  <TableCell>
                    {log.targetUser && (
                      <Typography variant="body2" display="block">
                        User: {log.targetUser.firstName} {log.targetUser.lastName}
                      </Typography>
                    )}
                    {log.targetChurch && (
                      <Typography variant="body2" display="block" color="text.secondary">
                        Church: {log.targetChurch.name}
                      </Typography>
                    )}
                    {!log.targetUser && !log.targetChurch && '-'}
                  </TableCell>
                </TableRow>
              ))}
              {logs.length === 0 && !loading && (
                <TableRow><TableCell colSpan={5} align="center">No audit logs found</TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default AuditLogs;
